export enum UserActivityType {
  Registration = 1,
  Login = 2,
  PasswordResetRequest = 3,
  PasswordResetSuccess = 4,
  ProjectClick = 5,
  PostRegistrationForm = 6,
  ProfileSurveyClick = 7,
  EmailChanged = 8,
  PasswordChanged = 9,
  Withdrawal = 10,
  TrustpilotRedirect = 11,
  UserDeletionInitiated = 12,
  ProjectTermination = 13,
  ProjectComplete = 14,
  EmailChangeRequest = 15,
  WithdrawalOptionChanged = 16,
  ProfileSurveyComplete = 17,
  ProfileSurveyEntry = 18,
  ProfileUpdated = 19,
  GameStart = 22,
  GameContinue = 23,
  GameGoalPaid = 24,
}
